import { ContentItemCategory } from '@/api/v4/content-items.api';
import { CALENDAR_DATE_FORMAT } from '@/constants';
import { useProject } from '@/features/projects/overview/use-project.query';
import { projectIdState } from '@/features/projects/project.state';
import { useCreateContentItem } from '@/features/settings/feed/sidebar/use-create-content-item.mutation';
import { useToggleContentItemSidebar } from '@/features/settings/feed/sidebar/use-toggle-content-item-sidebar';
import { draftJsRawToPlainText } from '@/helpers/draftjs';
import { formatDate } from '@/helpers/format-date';
import { getBaseUrl } from '@/helpers/generate-url-with-search-params';
import { paths } from '@/routes/helpers/paths';
import { useAtomValue } from 'jotai';

export const useCreateFeedFromProject = () => {
  const { createContentItem } = useCreateContentItem();
  const projectId = useAtomValue(projectIdState);
  const { data: project } = useProject(projectId);

  const { navigateToContentItemSidebar } = useToggleContentItemSidebar();

  const createFeedFromProject = async () => {
    if (!project) return;

    const newContentItem = await createContentItem({
      title: project.name.substring(0, 100),
      description: prepareContentItemDescription(project.problemStatement),
      uploadedDate: formatDate(new Date(), { format: CALENDAR_DATE_FORMAT }),
      tagIds: project.tags.slice(0, 3).map(t => t.id),
      category: ContentItemCategory.businessOpportunity,
      contentUrl: getBaseUrl() + paths.project({ projectId: project.id }),
      isVisible: false,
    });

    navigateToContentItemSidebar(newContentItem);
  };

  return { createFeedFromProject };
};

const prepareContentItemDescription = (original: string | null) => {
  if (!original) return 'Please describe what is the article about';

  const description = draftJsRawToPlainText(original);

  return description.slice(0, 300);
};
